<template>
  <SummaryBarMobile v-if="isMobile || isTablet" data-testid="summary-bar-mobile" />
  <SummaryBarDesktop v-else :style="{ top: `${summaryBarTopOffset}px` }" class="summary-bar-desktop" data-testid="summary-bar-desktop" />
</template>

<script setup lang="ts">
import SummaryBarDesktop from '~/components/shopTheCollection/summaryBar/SummaryBarDesktop.vue';
import SummaryBarMobile from '~/components/shopTheCollection/summaryBar/SummaryBarMobile.vue';

import { useDeviceType } from '~/composables/utils/useDeviceType';

withDefaults(
  defineProps<{
    summaryBarTopOffset?: number;
  }>(),
  {
    summaryBarTopOffset: 0,
  },
);

const { isMobile, isTablet } = useDeviceType();
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.summary-bar-desktop {
  display: block;
  width: 100%;
  max-width: 464px;
  position: sticky;
  transition: top $sticky-header-transition; // Match the exact transition timing of the StickyHeader
}

:deep() {
  // Fade animation for micro-animation
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
